"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedemptionStorage = void 0;
var cookie_storage_item_1 = require("./cookie-storage-item");
var json_storage_item_1 = require("./json-storage-item");
var RedemptionStorage = (function () {
    function RedemptionStorage() {
        this.key = "evelin.redemption";
        this.ttl = 60 * 60 * 24;
        this.storage = new json_storage_item_1.JsonStorageItem(new cookie_storage_item_1.CookieStorageItem(this.key, this.ttl));
    }
    RedemptionStorage.prototype.get = function () {
        var _a;
        return (_a = this.storage.get()) !== null && _a !== void 0 ? _a : {};
    };
    RedemptionStorage.prototype.setItem = function (key, value) {
        var _a;
        var redemption = this.get();
        this.storage.set(__assign(__assign({}, redemption), (_a = {}, _a[key] = value, _a)));
    };
    RedemptionStorage.prototype.removeItem = function (key) {
        var redemption = this.get();
        delete redemption[key];
        this.storage.set(redemption);
    };
    RedemptionStorage.prototype.isEnabled = function () {
        var enabled = this.get().enabled;
        return !!enabled;
    };
    RedemptionStorage.prototype.clear = function () {
        this.storage.remove();
    };
    return RedemptionStorage;
}());
exports.RedemptionStorage = RedemptionStorage;
//# sourceMappingURL=redemption-storage.js.map